// Civil-date utilities — the timezone law from CALENDAR-DESIGN.md.
// Dates are plain "YYYY-MM-DD" strings. "Today" always comes from the
// device clock. NEVER `new Date("YYYY-MM-DD")` — JS parses bare dates as
// UTC midnight, which is yesterday evening west of Greenwich. Lexicographic
// comparison is correct for this format; rendering goes through the LOCAL
// Date constructor (year, monthIndex, day).

const pad = (n) => String(n).padStart(2, '0');

export const toCivil = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export const todayStr = () => toCivil(new Date());

export const isValidCivil = (s) => /^\d{4}-\d{2}-\d{2}$/.test(s || '');

// Local Date from a civil string — safe for rendering/arithmetic only
export const civilToLocalDate = (s) => {
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d);
};

export const addDays = (s, n) => {
  const d = civilToLocalDate(s);
  d.setDate(d.getDate() + n);
  return toCivil(d);
};

// "Thu, Aug 14" — locale-aware, never UTC-shifted
export const fmtCivil = (s, opts = { weekday: 'short', month: 'short', day: 'numeric' }) =>
  civilToLocalDate(s).toLocaleDateString(undefined, opts);

export const isPast = (s) => isValidCivil(s) && s < todayStr();
export const isToday = (s) => s === todayStr();

// Monday-anchored start of week for a civil date
export const startOfWeek = (s) => {
  const d = civilToLocalDate(s);
  const shift = (d.getDay() + 6) % 7; // Mon=0 … Sun=6
  d.setDate(d.getDate() - shift);
  return toCivil(d);
};

export const startOfMonth = (s) => s.slice(0, 8) + '01';

export const monthLabel = (s) =>
  civilToLocalDate(startOfMonth(s)).toLocaleDateString(undefined, { month: 'long', year: 'numeric' });

export const addMonths = (s, n) => {
  const [y, m] = s.split('-').map(Number);
  const d = new Date(y, m - 1 + n, 1);
  return toCivil(d);
};
